export const wirasanaConstant = {
  whatsapp: "6281286540882",
  email: "info@wirasanarentacar.com",
  tel: "(0361) 286-066",
};
